import React, { useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const HeaderSettingsType = props => {
  const { classes } = props
  // State to track which position is selected (default is 'left')
  const [selectedPosition, setSelectedPosition] = useState('default')

  // Function to handle position selection
  const handleTypeSelect = position => {
    setSelectedPosition(position)
  }

  // Using direct color values instead of CSS variables
  const positionStyles = {
    selected: {
      border: '1px solid var(--mcg-blue, #015FFB)',
    },
    unselected: {
      border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    },
  }

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <Typography className={classes.header}>Header type</Typography>
      </div>
      <div className={classes.typeDiv}>
        <div
          className={classes.typeContent}
          onClick={() => handleTypeSelect('default')}
          style={
            selectedPosition === 'default'
              ? positionStyles.selected
              : positionStyles.unselected
          }
        >
          <img src="/assets/editor-file/landing-page/type-1.png"></img>
        </div>
        <div className={classes.typeTextDiv}>
          <Typography className={classes.positionText}>Default</Typography>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsType)
